@if (isPt) {
  <div class="pt-spinner">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" width="35" height="35" viewBox="0 0 35 35" style="width:100%;height:100%">
      <defs>
        <animateTransform repeatCount="indefinite" dur="4s" begin="0s" xlink:href="#_R_G_L_0_G_L_0_G_N_1_T_0" fill="freeze" attributeName="transform" from="0" to="720" type="rotate" additive="sum" keyTimes="0;0.5;1" values="0;360;720" keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833" calcMode="spline"/>
        <animateTransform repeatCount="indefinite" dur="4s" begin="0s" xlink:href="#_R_G_L_0_G_L_0_G_N_1_T_0" fill="freeze" attributeName="transform" from="-50 -50" to="-50 -50" type="translate" additive="sum" keyTimes="0;1" values="-50 -50;-50 -50" keySplines="0 0 1 1" calcMode="spline"/>
        <animate attributeType="XML" attributeName="opacity" dur="4s" from="0" to="1" xlink:href="#time_group"/>
      </defs>
      <g id="_R_G">
        <g id="_R_G_L_0_G" transform=" translate(17.5, 17.5) scale(0.05306, 0.05306) translate(-656, -656.5)">
          <g id="_R_G_L_0_G_L_1_G" transform=" translate(655.915, 656.208) translate(-318.09, -318.09)">
            <path id="_R_G_L_0_G_L_1_G_D_0_P_0" fill="#0c0f18" fill-opacity="1" fill-rule="nonzero" d=" M318.09 0.25 C142.55,0.25 0.25,142.55 0.25,318.09 C0.25,493.63 142.55,635.93 318.09,635.93 C493.63,635.93 635.93,493.63 635.93,318.09 C635.93,142.55 493.63,0.25 318.09,0.25z  M318.09 489.09 C223.65,489.09 147.09,412.53 147.09,318.09 C147.09,223.65 223.65,147.09 318.09,147.09 C412.53,147.09 489.09,223.65 489.09,318.09 C489.09,412.53 412.53,489.09 318.09,489.09z "/>
          </g>
          <g id="_R_G_L_0_G_L_0_G_N_1_T_0" transform=" translate(656, 656.5)">
            <g id="_R_G_L_0_G_L_0_G" transform=" translate(123.335, 49.708) translate(-244.67, -244.67)">
              <path id="_R_G_L_0_G_L_0_G_D_0_P_0" fill="#ef0000" fill-opacity="1" fill-rule="nonzero" d=" M244.67 0.25 C109.68,0.25 0.25,109.68 0.25,244.67 C0.25,379.66 109.68,489.09 244.67,489.09 C379.66,489.09 489.09,379.66 489.09,244.67 C489.09,109.68 379.66,0.25 244.67,0.25z  M171.25 415.67 C76.81,415.67 0.25,339.11 0.25,244.67 C0.25,150.23 76.81,73.67 171.25,73.67 C265.69,73.67 342.25,150.23 342.25,244.67 C342.25,339.11 265.69,415.67 171.25,415.67z "/>
            </g>
          </g>
        </g>
      </g>
      <g id="time_group"/>
    </svg>
  </div>
} @else {
  <div class="pt-spinner">
    <div class="pt-spinner__circles">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
}
